import { render } from "./NavigationAccountItem.vue?vue&type=template&id=9527374c&scoped=true"
import script from "./NavigationAccountItem.vue?vue&type=script&lang=js"
export * from "./NavigationAccountItem.vue?vue&type=script&lang=js"

import "./NavigationAccountItem.vue?vue&type=style&index=0&id=9527374c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9527374c"]])

export default __exports__